module.exports = __webpack_public_path__ + "img/logoTxt.de9ccd35.png";